"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var InputAdornment = function (_a) {
    var classes = _a.classes, _b = _a.disablePointerEvents, disablePointerEvents = _b === void 0 ? false : _b, _c = _a.disableTypography, disableTypography = _c === void 0 ? false : _c, _d = _a.position, position = _d === void 0 ? 'start' : _d, variant = _a.variant, children = _a.children, _e = _a.component, component = _e === void 0 ? 'div' : _e;
    return (react_1.default.createElement(InputAdornment_1.default, { classes: classes, disablePointerEvents: disablePointerEvents, disableTypography: disableTypography, position: position, variant: variant, component: component }, children));
};
exports.default = InputAdornment;
